import qs from 'query-string';
import {useLocation} from "react-router-dom";

function useQuery() {
    const location = useLocation();

    return qs.parse(location.search);
}

export default useQuery;